import { FETCH_SITE_REPORT_DATA } from './constants';

export function fetchSiteReportData(args) {
  return {
    type: FETCH_SITE_REPORT_DATA,
    payload: args,
  };
}
